import * as _ from 'lodash';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiModel } from 'models';
import { BuyingSelectionOverviewSearch, BuyingSelection } from './buying-selection.types';
import { AvailableLanguage } from 'helpers';

@Injectable()
export class BuyingSelectionService {
    private readonly itemsPerPage = 30;

    constructor(private apiModel: ApiModel) {}

    public getBuyingSelections({
        brandId,
        pagination
    }: {
        brandId: string;
        pagination: {
            afterId: string;
            itemsPerPage?: number;
        };
    }): Observable<BuyingSelectionOverviewSearch> {
        const itemsPerPage = pagination.itemsPerPage ? pagination.itemsPerPage : this.itemsPerPage;
        const afterIdQueryStr = pagination.afterId ? `&afterId=${pagination.afterId}` : '';
        const urlGetAll = `${this.apiModel.getBuyingSelectionEndpoint()}?brandId=${brandId}&limit=${itemsPerPage}${afterIdQueryStr}`;

        return this.apiModel.makeHttpObservableRequest({ method: 'GET', url: urlGetAll });
    }

    public getBuyingSelection(buyingSelectionId: string, language?: AvailableLanguage): Observable<BuyingSelection> {
        const url = `${this.apiModel.getBuyingSelectionEndpoint()}/${buyingSelectionId}?language=${language}`;
        return this.apiModel.makeHttpObservableRequest({ method: 'GET', url });
    }
}
